/*
  cromatica-cart.js  v7
  Mini-carrito para Cromática Stickers
  El drawer se abre desde el ícono del carrito del header (a.header__icon--cart)
  Incluir en layout/theme.liquid antes de </body>:
    <script src="{{ 'cromatica-cart.js' | asset_url }}" defer></script>

  Cambios v7:
   - ELIMINADA la barra de envío (mensaje + barra de progreso) del drawer.
     Stickers y etiquetas ahora tienen políticas de envío distintas
     (stickers gratis desde $1,500, etiquetas desde $3,500) y el carrito
     es compartido, así que un solo umbral confundía al cliente. La
     política de envío se comunica en cada calculadora.
   - Eliminadas las constantes ENVIO_GRATIS y ENVIO_COSTO.
  Cambios v6:
   - ENVIO_GRATIS 1500 → 2500 (alineado con las 8 calculadoras).
   - NUEVA constante ENVIO_COSTO = 200. El mensaje del drawer ahora
     informa el costo de envío cuando no se alcanza el umbral, en vez
     de solo decir cuánto falta.
  Cambios v5:
   - FIX título duplicado: "Stickers con Relieve Relieve Blanco..." →
     "Stickers con Relieve Blanco..." (quita palabras repetidas entre
     tipo y material antes de concatenar).
   - NUEVO: indicador "tinta blanca" visible en el drawer cuando
     item.base_blanca lo indica (VT/VH/Relieve).
   - NUEVO: badge "+ $400 preparación de archivo" visible en el drawer
     cuando item.servicio_archivo lo indica, para que el cliente vea
     por qué el total incluye ese cargo.
*/
(function () {
  'use strict';

  const NETLIFY_URL  = 'https://cromatica-stickers-checkout.netlify.app/.netlify/functions/crear-orden';
  const STORAGE_KEY  = 'cr_cart_v1';

  function loadCart() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch { return []; }
  }
  function saveCart(items) { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); }
  function cartTotal(items) { return items.reduce((s, i) => s + parseFloat(i.precio_total), 0); }

  // Detecta valores afirmativos en cualquiera de los dos formatos que mandan
  // las calculadoras: 'si' (etiquetas) o 'Sí (+$400)' / 'Sí' (stickers)
  function isYes(v) {
    if (!v) return false;
    const s = v.toString().trim().toLowerCase();
    return s.startsWith('si') || s.startsWith('sí');
  }

  // Arma el título del item evitando palabras repetidas entre tipo y material
  // (ej. tipo="Stickers con Relieve" + material="Relieve Blanco Brillante"
  //  → "Stickers con Relieve Blanco Brillante", sin duplicar "Relieve")
  function tituloFor(item) {
    const tipo = (item.tipo || '').trim();
    let material = (item.material || '').trim() || (tipo ? '' : 'Vinil Blanco');
    if (tipo && material) {
      const tipoLower = tipo.toLowerCase();
      const palabras = material.split(' ');
      while (palabras.length && tipoLower.includes(palabras[0].toLowerCase())) {
        palabras.shift();
      }
      material = palabras.join(' ');
    }
    return tipo ? `${tipo} ${material}`.trim() : (material || 'Vinil Blanco');
  }

  window.CrCart = {
    add(item) {
      const items = loadCart();
      items.push({ ...item, id: Date.now() });
      saveCart(items);
      renderCart();
      openDrawer();

      // Meta Pixel — AddToCart con validación estricta de value
      if (typeof fbq === 'function') {
        const value = parseFloat(item.precio_total);
        const numItems = parseInt(item.cantidad);

        if (!isNaN(value) && value > 0) {
          const contentName = item.tipo
            ? `${item.tipo} ${item.material || ''}`.trim()
            : `Etiquetas ${item.material || 'Vinil Blanco'}`;

          fbq('track', 'AddToCart', {
            value: value,
            currency: 'MXN',
            content_type: 'product',
            content_name: contentName,
            num_items: !isNaN(numItems) && numItems > 0 ? numItems : 1
          });
        } else {
          console.warn('[CrCart] AddToCart NO disparado: precio_total inválido', item);
        }
      }
    },
    remove(id) { saveCart(loadCart().filter(i => i.id !== id)); renderCart(); },
    clear()    { saveCart([]); renderCart(); }
  };

  function injectHTML() {
    document.head.insertAdjacentHTML('beforeend', `
      <style id="cr-cart-style">
        #cr-cart-fab { display: none !important; }

        .cr-header-badge {
          position: absolute; top: -5px; right: -5px;
          background: #ff3b30; color: #fff;
          font-size: 10px; font-weight: 700;
          min-width: 18px; height: 18px; border-radius: 9px;
          display: none; align-items: center; justify-content: center;
          padding: 0 4px; pointer-events: none; z-index: 10;
          font-family: "DM Sans", -apple-system, sans-serif;
        }
        .cr-header-badge.visible { display: flex; }

        #cr-cart-overlay {
          position: fixed; inset: 0; background: rgba(0,0,0,.45);
          z-index: 9001; opacity: 0; pointer-events: none;
          transition: opacity .25s;
        }
        #cr-cart-overlay.cr-open { opacity: 1; pointer-events: auto; }

        #cr-cart-drawer {
          position: fixed; top: 0; right: 0; bottom: 0;
          width: min(420px, 100vw); background: #fff;
          z-index: 9002; transform: translateX(100%);
          transition: transform .3s cubic-bezier(.4,0,.2,1);
          display: flex; flex-direction: column;
          font-family: "DM Sans", -apple-system, sans-serif;
        }
        #cr-cart-drawer.cr-open { transform: translateX(0); }

        #cr-drawer-head {
          display: flex; align-items: center; justify-content: space-between;
          padding: 20px 20px 16px; border-bottom: 1px solid #e5e5e5;
        }
        #cr-drawer-head h2 { font-size: 18px; font-weight: 700; color: #111; margin: 0; }
        #cr-drawer-close {
          background: none; border: none; cursor: pointer;
          padding: 6px; color: #888; font-size: 22px; line-height: 1;
        }
        #cr-drawer-close:hover { color: #111; }

        #cr-drawer-body { flex: 1; overflow-y: auto; padding: 16px 20px; }

        .cr-item {
          display: flex; gap: 12px; padding: 14px 0;
          border-bottom: 1px solid #f0f0f0;
        }
        .cr-item:last-child { border-bottom: none; }
        .cr-item-icon {
          width: 44px; height: 44px; border-radius: 10px;
          background: #e8f4fb; display: flex; align-items: center;
          justify-content: center; flex-shrink: 0; font-size: 20px;
        }
        .cr-item-info { flex: 1; min-width: 0; }
        .cr-item-title {
          font-size: 14px; font-weight: 600; color: #111; margin-bottom: 3px;
          white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
        }
        .cr-item-sub { font-size: 12px; color: #888; line-height: 1.5; }
        .cr-item-service {
          font-size: 11px; font-weight: 700; color: #0096ea;
          margin-top: 3px; line-height: 1.4;
        }
        .cr-item-right {
          display: flex; flex-direction: column;
          align-items: flex-end; gap: 6px; flex-shrink: 0;
        }
        .cr-item-price { font-size: 15px; font-weight: 700; color: #111; }
        .cr-item-del {
          background: none; border: none; cursor: pointer;
          color: #ccc; font-size: 18px; padding: 2px; line-height: 1;
          transition: color .15s;
        }
        .cr-item-del:hover { color: #ff3b30; }

        #cr-cart-empty { text-align: center; padding: 48px 20px; color: #aaa; }
        #cr-cart-empty p { font-size: 15px; margin-top: 12px; }

        #cr-drawer-foot { padding: 16px 20px 28px; border-top: 1px solid #e5e5e5; }

        #cr-discount-wrap { margin-bottom: 14px; }
        #cr-discount-row { display: flex; gap: 8px; }
        #cr-discount-input {
          flex: 1; padding: 11px 14px;
          border: 1.5px solid #d2d2d7; border-radius: 10px;
          font-family: "DM Sans", -apple-system, sans-serif;
          font-size: 14px; color: #1a1a1a; background: #f5f5f7;
          text-transform: uppercase; letter-spacing: .05em; outline: none;
          transition: border-color .2s;
        }
        #cr-discount-input:focus { border-color: #0096ea; background: #fff; }
        #cr-discount-btn {
          padding: 11px 14px; border: 1.5px solid #d2d2d7; border-radius: 10px;
          background: #f5f5f7; font-family: "DM Sans", -apple-system, sans-serif;
          font-size: 13px; font-weight: 600; color: #0096ea;
          cursor: pointer; white-space: nowrap; transition: all .15s;
        }
        #cr-discount-btn:hover { background: #e8f4fb; border-color: #0096ea; }
        #cr-discount-btn:disabled { opacity: .6; cursor: default; }
        #cr-discount-msg { font-size: 12px; margin-top: 5px; min-height: 16px; }

        #cr-subtotal-row {
          display: flex; justify-content: space-between;
          align-items: baseline; margin-bottom: 14px;
        }
        #cr-subtotal-row span { font-size: 14px; color: #555; }
        #cr-subtotal-row strong { font-size: 20px; font-weight: 700; color: #111; }

        #cr-checkout-btn {
          width: 100%; padding: 17px; background: #0096ea; color: #fff;
          border: none; border-radius: 12px; font-family: inherit;
          font-size: 16px; font-weight: 700; cursor: pointer; transition: all .2s;
        }
        #cr-checkout-btn:hover {
          background: #0082cc; transform: translateY(-1px);
          box-shadow: 0 6px 20px rgba(0,150,234,.3);
        }
        #cr-checkout-btn:disabled {
          background: #b0d8f5; cursor: default; transform: none; box-shadow: none;
        }
        #cr-checkout-btn .cr-btn-sub {
          font-size: 12px; font-weight: 400; opacity: .85; margin-top: 2px;
        }
        #cr-clear-btn {
          width: 100%; margin-top: 10px; background: none; border: none;
          font-family: inherit; font-size: 13px; color: #aaa; cursor: pointer; padding: 6px;
        }
        #cr-clear-btn:hover { color: #ff3b30; }
      </style>
    `);

    document.body.insertAdjacentHTML('beforeend', `
      <button id="cr-cart-fab" aria-hidden="true" style="display:none"></button>
      <div id="cr-cart-overlay"></div>
      <div id="cr-cart-drawer" role="dialog" aria-modal="true" aria-label="Carrito">
        <div id="cr-drawer-head">
          <h2>🛒 Tu carrito</h2>
          <button id="cr-drawer-close" aria-label="Cerrar">✕</button>
        </div>
        <div id="cr-drawer-body"></div>
        <div id="cr-drawer-foot">
          <div id="cr-discount-wrap">
            <div id="cr-discount-row">
              <input id="cr-discount-input" type="text" placeholder="Código de descuento"
                autocomplete="off" autocorrect="off" autocapitalize="characters" spellcheck="false">
              <button id="cr-discount-btn" type="button">Aplicar</button>
            </div>
            <div id="cr-discount-msg"></div>
          </div>
          <div id="cr-subtotal-row">
            <span>Subtotal (IVA inc.)</span>
            <strong id="cr-subtotal">$0 MXN</strong>
          </div>
          <button id="cr-checkout-btn" disabled>
            <div>Ir al checkout</div>
            <div class="cr-btn-sub">Pago seguro · Shopify</div>
          </button>
          <button id="cr-clear-btn">Vaciar carrito</button>
        </div>
      </div>
    `);
  }

  function updateHeaderBadge(count) {
    const cartLink = document.querySelector('a.header__icon--cart');
    if (!cartLink) return;
    cartLink.style.position = 'relative';
    let badge = cartLink.querySelector('.cr-header-badge');
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'cr-header-badge';
      cartLink.appendChild(badge);
    }
    badge.textContent = count;
    badge.classList.toggle('visible', count > 0);
  }

  // ── Fix 1: emojis para todos los materiales ──────────────────────────────
  function materialIcon(material, tipo) {
    const m = (material || '').toLowerCase();
    const t = (tipo || '').toLowerCase();
    if (m.includes('holo') || t.includes('holo')) return '🌈';
    if (m.includes('trans'))                       return '🔲';
    if (m.includes('dor') || m.includes('gold'))  return '🥇';
    if (m.includes('plat') || m.includes('silver')) return '🥈';
    if (t.includes('sticker'))                     return '⭐';
    return '🏷️';
  }
  // ─────────────────────────────────────────────────────────────────────────

  function renderCart() {
    const items = loadCart();
    const total = cartTotal(items);
    const count = items.length;

    updateHeaderBadge(count);

    const body = document.getElementById('cr-drawer-body');
    if (!body) return;

    if (count === 0) {
      body.innerHTML = `
        <div id="cr-cart-empty">
          <div style="font-size:48px">🛒</div>
          <p>Tu carrito está vacío.<br>Calcula y agrega tus etiquetas.</p>
        </div>`;
    } else {
      body.innerHTML = items.map(item => {
        const ac  = item.acabado && item.acabado !== 'sin_barniz' ? ' · ' + item.acabado : '';
        const col = item.color ? ' ' + item.color : '';

        // ── Fix v5: tinta blanca visible junto al tamaño/cantidad ──────────
        const tintaBlanca = isYes(item.base_blanca) ? ' · tinta blanca' : '';
        // ── Fix v5: badge de servicio de archivo cuando el cliente lo pagó ─
        const conServicio = isYes(item.servicio_archivo);

        // ── Fix v5: título sin palabras duplicadas (tipo + material) ───────
        const titulo = tituloFor(item);
        // ──────────────────────────────────────────────────────────────────
        return `
          <div class="cr-item">
            <div class="cr-item-icon">${materialIcon(item.material, item.tipo)}</div>
            <div class="cr-item-info">
              <div class="cr-item-title">${titulo}${col}</div>
              <div class="cr-item-sub">${item.ancho}×${item.alto} cm · ${parseInt(item.cantidad).toLocaleString('es-MX')} pzas${ac}${tintaBlanca}</div>
              <div class="cr-item-sub">$${parseFloat(item.precio_unitario).toFixed(2)}/u</div>
              ${conServicio ? '<div class="cr-item-service">+ $400 preparación de archivo</div>' : ''}
            </div>
            <div class="cr-item-right">
              <span class="cr-item-price">$${parseFloat(item.precio_total).toLocaleString('es-MX')}</span>
              <button class="cr-item-del" data-id="${item.id}" aria-label="Eliminar">✕</button>
            </div>
          </div>`;
      }).join('');

      body.querySelectorAll('.cr-item-del').forEach(btn => {
        btn.addEventListener('click', () => window.CrCart.remove(parseInt(btn.dataset.id)));
      });
    }

    const sub = document.getElementById('cr-subtotal');
    if (sub) sub.textContent = '$' + total.toLocaleString('es-MX', { minimumFractionDigits: 0 }) + ' MXN';

    const btn = document.getElementById('cr-checkout-btn');
    if (btn) btn.disabled = count === 0;
  }

  function openDrawer() {
    document.getElementById('cr-cart-drawer')?.classList.add('cr-open');
    document.getElementById('cr-cart-overlay')?.classList.add('cr-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    document.getElementById('cr-cart-drawer')?.classList.remove('cr-open');
    document.getElementById('cr-cart-overlay')?.classList.remove('cr-open');
    document.body.style.overflow = '';
  }

  async function doCheckout() {
    const items = loadCart();
    if (!items.length) return;

    const btn = document.getElementById('cr-checkout-btn');
    btn.disabled = true;
    btn.innerHTML = '<div>Procesando…</div><div class="cr-btn-sub">Un momento</div>';

    try {
      const res = await fetch(NETLIFY_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items,
          discount_code: window._crDiscountCode || null
        })
      });
      const data = await res.json();
      if (data.checkout_url) {
        window.CrCart.clear();
        closeDrawer();
        window.location.href = data.checkout_url;
      } else {
        throw new Error('Sin URL');
      }
    } catch (err) {
      alert('Error al procesar tu pedido. Por favor intenta de nuevo.');
      btn.disabled = false;
      btn.innerHTML = '<div>Ir al checkout</div><div class="cr-btn-sub">Pago seguro · Shopify</div>';
    }
  }

  function init() {
    injectHTML();
    renderCart();

    function hijackCartIcon() {
      const cartLink = document.querySelector('a.header__icon--cart');
      if (cartLink && !cartLink.dataset.crHijacked) {
        cartLink.dataset.crHijacked = '1';
        cartLink.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          openDrawer();
        });
      }
    }
    hijackCartIcon();
    setTimeout(hijackCartIcon, 800);
    setTimeout(hijackCartIcon, 2000);

    document.getElementById('cr-cart-overlay').addEventListener('click', closeDrawer);
    document.getElementById('cr-drawer-close').addEventListener('click', closeDrawer);
    document.getElementById('cr-checkout-btn').addEventListener('click', doCheckout);

    // ── Código de descuento ──────────────────────────────────────────────
    window._crDiscountCode = null;

    document.getElementById('cr-discount-btn').addEventListener('click', function () {
      const input = document.getElementById('cr-discount-input');
      const msg   = document.getElementById('cr-discount-msg');
      const code  = input.value.trim().toUpperCase();
      if (!code) return;

      window._crDiscountCode  = code;
      msg.style.color         = '#16a34a';
      msg.textContent         = '✓ Código aplicado — el descuento se verá en el checkout';
      input.style.borderColor = '#16a34a';
    });
    // ────────────────────────────────────────────────────────────────────

    document.getElementById('cr-clear-btn').addEventListener('click', () => {
      if (confirm('¿Vaciar el carrito?')) window.CrCart.clear();
    });

    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();